module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map__wrapper"
  }, [(_vm.mapHeader) ? _c('div', {
    staticClass: "map__header"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('span', {
    staticClass: "header__title"
  }, [_vm._v(_vm._s(_vm.headerTitle))]), _vm._v(" "), _c('span', {
    staticClass: "header__description",
    domProps: {
      "innerHTML": _vm._s(_vm.headerDescription)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "map"
    }
  }), _vm._v(" "), (_vm.mapLegend) ? _c('div', {
    staticClass: "map__legend"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('span', {
    staticClass: "legend-label"
  }, [_vm._v("Légende :")]), _vm._v(" "), _c('ul', {
    staticClass: "legend-list"
  }, _vm._l((_vm.legends), function(legend) {
    return _c('li', {
      staticClass: "legend-list-item"
    }, [_c('img', {
      staticClass: "attachment-80x60",
      attrs: {
        "width": "32",
        "height": "37",
        "src": legend.icon,
        "title": legend.name,
        "alt": ("Icône " + (legend.name))
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "legend-list-text"
    }, [_vm._v(_vm._s(legend.name))])])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn-map",
    on: {
      "click": _vm.proximityClick
    }
  }, [_c('svg', {
    staticClass: "icon icon-map",
    attrs: {
      "aria-hidden": "true",
      "role": "img"
    }
  }, [_c('use', {
    attrs: {
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "xlink:href": "#icon-map"
    }
  })]), _vm._v("\n    A proximité\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-094bb0d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Maps.vue
// module id = 137
// module chunks = 2